function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./dist/ng2-pagination'));



//////////////////
// WEBPACK FOOTER
// ./~/ng2-pagination/index.js
// module id = 508
// module chunks = 33